import _query from "../../../actions/_query";
import getLSKeywords from '../../../utils/entities/getLSKeywords';
import {

  // all the old-apis
  // KEYWORD_REQUEST_API,
  // EXPERT_HISTOGRAM_API,
  // EXPERT_BIO_COLLABS_API,
  // EXPERT_BIO_COLLABS_MULTI_API,
  // EXPERT_CREDENTIALS_API,
  // EXPERT_ARTICLES_API,
  // EXPERT_ARTICLES_MULTI_API,
  // EXPERT_TRIALS_API,
  // EXPERT_GRANTS_API,
  // EXPERT_MSA_ARTICLES_API,
  // OPEN_PAYEMENT,
  // EXPERTS_EXTERNAL_LINKS_API,

  // all the new-apis
  APP_EXPERT_BIO_HISTOGRAM,
  APP_EXPERT_BIO_GRANTS,
  APP_EXPERT_BIO_TOP_COLLABS,
  APP_EXPERT_BIO_MULTI_COLLABS,
  APP_EXPERT_BIO_CREDENTIALS,
  APP_EXPERT_BIO_TRIALS,
  APP_EXPERT_KEYWORD_RANKS,
  APP_EXPERT_BIO_ARTICLES,
  APP_EXPERT_BIO_MULTI_ARTICLES,
  APP_EXPERT_MSA_ARTICLES,
  APP_EXPERT_PAYMENTS_API,
  APP_EXPERT_BIO_EXTERNAL_LINKS,
  APP_EXPERT_BIO_LINKS_PREVIEW,
  APP_EXPERT_PATENTS_API
} from "../../../constants/_api";

export const getKeywordRanks = async (token, method, body) => {
  const url = APP_EXPERT_KEYWORD_RANKS;
  try {
    let data = await _query(url, token, method, body);
    data = await data.json();
    if (data.error) throw new Error("Something went wrong for Keyword-Ranks API!");
    return data.body;
  } catch (err) {
    console.log(err);
  }
};

export const getHistogram = async (token, params) => {
  let { expertId, keyword, expertin, showFullProfile, moduleId, entities } = params || {};
  let url = APP_EXPERT_BIO_HISTOGRAM;
  let body = { expertId, keyword, expertin, showFullProfile, moduleId, entities };
  try {
    let data = await _query(url, token, "POST", body);
    data = await data.json();

    if (data.error) throw new Error("Something went wrong for Histogram API!");
    return data.body;
  } catch (err) {
    console.log(err);
  }
};

export const getCollabs = async (token, params) => {
  let { expertId, keyword, expertin, showFullProfile, moduleId, entities } = params;

  let url = APP_EXPERT_BIO_TOP_COLLABS;
  let body = { expertId, keyword, expertin, showFullProfile, moduleId, entities };
  if (!keyword) body = { expertId, expertin, showFullProfile, moduleId };

  try {
    let data = await _query(url, token, "POST", body);
    data = await data.json();
    if (data.error) throw new Error("Something went wrong for Collabs API!");
    return data.body;
  } catch (err) {
    console.log(err);
  }
};

export const getCollabsMultiple = async (token, params) => {
  let { keywords, expertId, moduleId } = params;
  if (!keywords) {
    return;
  }

  let url = `${APP_EXPERT_BIO_MULTI_COLLABS}`;
  let body = {
    keywords,
    expertId,
    token,
    moduleId,
  };

  try {
    let data = await _query(url, token, "POST", body);
    data = await data.json();

    if (data.error) throw new Error("Something went wrong for Collabs-Multiple API!");
    return data.body;
  } catch (err) {
    console.log(err);
  }
};

export const getCredentials = async (token, params) => {
  let { expertId, expertin, showFullProfile, moduleId, keyword, entities, filters, customFilters } = params || {};
  filters = filters || {};
  if (entities) {
    entities = getLSKeywords(entities)
  };
  let url = APP_EXPERT_BIO_CREDENTIALS;
  let body = { 
    ...filters,
    expertId, expertin, showFullProfile, moduleId, entities, customFilters };
  if (keyword) body = { ...body, keyword, entities, customFilters };

  try {
    let data = await _query(url, token, "POST", body);
    data = await data.json();


    try{
      if(data.body.msg === 'ACCESS DENIED'){
        window.location.href = '/account-create';
        return;
      }
    } catch(err){
      console.log(err)
    }
    if (data.error) throw new Error("Something went wrong for Credentials API!");
    return data.body;
  } catch (err) {
    console.log(err);
  }
};

export const getArticles = async (token, params) => {
  let {
    expertId,
    keyword,
    size,
    from,
    expertin,
    sort = "citation",
    showFullProfile,
    moduleId,
    entities,
    filters,
    customFilters
  } = params || {};
  filters = filters || {};

  let url = APP_EXPERT_BIO_ARTICLES;
  let body = {
    ...filters,
    expertId,
    keyword,
    size,
    from,
    expertin,
    sort,
    showFullProfile,
    moduleId,
    entities,
    customFilters
  };

  try {
    let data = await _query(url, token, "POST", body);
    data = await data.json();

    if (data.error) throw new Error("Something went wrong for Articles API!");
    return data.body;
  } catch (err) {
    console.log(err);
  }
};

export const getMoreArticles = async (token, params) => {
  let {
    expertId,
    keyword,
    size,
    from,
    expertin,
    sort = "citation",
    showFullProfile,
    moduleId,
    entities
  } = params || {};

  let url = APP_EXPERT_BIO_ARTICLES;
  let body = {
    expertId,
    keyword,
    size,
    from,
    expertin,
    sort,
    showFullProfile,
    moduleId,
    entities
  };

  try {
    let data = await _query(url, token, "POST", body);
    data = await data.json();

    if (data.error) throw new Error("Something went wrong for More-Articles API!");
    return data.body;
  } catch (err) {
    console.log(err);
  }
};

export const getArticlesMultiple = async (token, params) => {
  let { expertId, keywords, size, from, moduleId } = params || {};
  if (!keywords) {
    return;
  }

  let url = APP_EXPERT_BIO_MULTI_ARTICLES;
  let body = {
    expertId,
    keywords,
    size,
    from,
    moduleId,
  };

  try {
    let data = await _query(url, token, "POST", body);
    data = data.json();

    if (data.error) throw new Error("Something went wrong for Multiple-Articles API!");
    return data.body;
  } catch (err) {
    console.log(err);
  }
};

export const getArticlesMultipleMore = async (token, params) => {
  let { expertId, keywords, size, from, sort = "citation", moduleId } =
    params || {};
  if (!keywords) {
    return;
  }

  let url = APP_EXPERT_BIO_MULTI_ARTICLES;
  let body = {
    expertId,
    keywords,
    size,
    from,
    sort,
    moduleId,
  };

  try {
    let data = await _query(url, token, "POST", body);
    data = data.json();

    if (data.error) throw new Error("Something went wrong for Articles-Multiple-More API!");
    return data.body;
  } catch (err) {
    console.log(err);
  }
};

export const getClinicalTrials = async (token, params) => {
  let {
    expertId,
    keyword,
    expertin,
    isMulti: ismulti,
    from = 0,
    size = 10,
    moduleId,
    showFullProfile,
    entities
  } = params || {};
  let url = APP_EXPERT_BIO_TRIALS;
  let body = { expertId, keyword, expertin, ismulti, from, size, moduleId, showFullProfile, entities };
  try {
    let data = await _query(url, token, "POST", body);
    data = await data.json();

    if (data.error) throw new Error("Something went wrong for Clinical-Trials API!");
    return data.body;
  } catch (err) {
    console.log(err);
  }
};

export const getGrants = async (token, params) => {
  let { expertId, keyword, size, from, moduleId, entities } = params || {};
  let url = APP_EXPERT_BIO_GRANTS;

  let body = { expertId, keyword, size, from, moduleId, entities };
  if (!keyword) body = { expertId, size, from, moduleId };

  try {
    let data = await _query(url, token, "POST", body);
    data = await data.json();

    if (data.error) throw new Error("Something went wrong for Grants API!");
    return data.body;
  } catch (err) {
    console.log(err);
  }
};

export const getPatents = async (token, params) => {
  let { expertId, keyword, size, from, moduleId, entities } = params || {};
  let url = APP_EXPERT_PATENTS_API;

  let body = { expertId, keyword, size, from, moduleId, entities };
  if (!keyword) body = { expertId, size, from, moduleId };

  try {
    let data = await _query(url, token, "POST", body);
    data = await data.json();

    if (data.error) throw new Error("Something went wrong for Grants API!");
    return data.body;
  } catch (err) {
    console.log(err);
  }
};



export const getMoreGrants = async (token, params) => {
  let { expertId, keyword, size, from, moduleId, entities } = params || {};
  let url = APP_EXPERT_BIO_GRANTS;

  let body = { expertId, keyword, size, from, moduleId, entities };
  if (!keyword) body = { expertId, size, from, moduleId };

  try {
    let data = await _query(url, token, "POST", body);
    data = await data.json();

    if (data.error) throw new Error("Something went wrong for More-Grants API!");
    return data.body;
  } catch (err) {
    console.log(err);
  }
};

export const getMsArticles = async (token, params) => {
  let { expertId, keyword, size, from, moduleId, entities } = params || {};
  let url = APP_EXPERT_MSA_ARTICLES;
  let body = { expertId, keyword, size, from, moduleId, entities };
  try {
    let data = await _query(url, token, "POST", body);
    data = await data.json();

    if (data.error) throw new Error("Something went wrong for MS-Articles API!");
    return data.body;
  } catch (err) {
    console.log(err);
  }
};

export const getMoreMsArticles = async (token, params) => {
  let { expertId, keyword, size, from, moduleId, entities } = params || {};
  let url = APP_EXPERT_MSA_ARTICLES;
  let body = { expertId, keyword, size, from, moduleId, entities };
  try {
    let data = await _query(url, token, "POST", body);
    data = await data.json();

    if (data.error) throw new Error("Something went wrong for More-MS-Articles API!");
    return data.body;
  } catch (err) {
    console.log(err);
  }
};

export const getPayments = async (token, params) => {
  let { expertId, keyword, size, from, moduleId, entities, showFullProfile } = params || {};
  let url = APP_EXPERT_PAYMENTS_API;
  let body = { expertId, keyword, size, from, moduleId, entities, showFullProfile };
  try {
    let data = await _query(url, token, "POST", body);
    data = await data.json();

    if (data.error) throw new Error("Something went wrong for Payments-API!");
    return data.body;
  } catch (err) {
    console.log(err);
  }
};

export const getMorePayments = async (token, params) => {
  let { expertId, keyword, size, from, moduleId, entities, showFullProfile } = params || {};
  let url = APP_EXPERT_PAYMENTS_API;
  let body = { expertId, keyword, size, from, moduleId, entities, showFullProfile };
  try {
    let data = await _query(url, token, "POST", body);
    data = await data.json();

    if (data.error) throw new Error("Something went wrong for More-Payments API!");
    return data.body;
  } catch (err) {
    console.log(err);
  }
};

export const getExternalLinks = async (token, params) => {
  let { expertId, moduleId } = params || {};
  let url = APP_EXPERT_BIO_EXTERNAL_LINKS;
  let body = { expertId, moduleId };
  try {
    let data = await _query(url, token, "POST", body);
    data = await data.json();

    if (data.error) throw new Error("Something went wrong for External-Links API!");
    return data.body;
  } catch (err) {
    console.log(err);
  }
};

export const getLinksPreviewData = async (token, params) => {
  let { moduleId, links } = params || {};
  const url = APP_EXPERT_BIO_LINKS_PREVIEW;
  const body = { moduleId, links };

  const queryBody = _query(url, token, "POST", body);

  try {
    let data = await _query(url, token, "POST", body);
    data = await data.json();

    if (data.error) throw new Error("Something went wrong for Links-Preview API!");
    return data.body;
  } catch (err) {
    console.log(err);
  }
}